<app-chart [title]="title" [tooltip]="tooltip">
    <canvas baseChart *ngIf="chartData" [type]="'bar'" [data]="chartData" [options]="chartOptions" [plugins]="[dataLabelsPlugin]"> </canvas>
</app-chart>
